import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/integrations/supabase/client'

export const useCertNumbers = () => {
  const { data: customNumbers, refetch } = useQuery({
    queryKey: ['available-numbers'],
    queryFn: async () => {
      console.log('Fetching available numbers...')
      const { data: allNumbers, error } = await supabase
        .rpc('generate_cert_numbers')
        .then(async () => {
          const { data, error } = await supabase
            .from('cert_applications')
            .select('cert_number')
            .eq('domain', 'PENDING')
            .order('created_at', { ascending: false })
          return { data, error }
        })

      if (error) {
        console.error('Error fetching numbers:', error)
        throw error
      }

      if (!allNumbers) {
        console.error('No numbers found')
        return {
          threeDigit: [],
          sixDigit: [],
          eightDigit: []
        }
      }

      console.log('Total numbers fetched:', allNumbers.length)

      // Randomly select 6 numbers for each category
      const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      }

      const threeDigitNumbers = shuffleArray(
        allNumbers.filter(n => n.cert_number.length === 3)
          .map(n => n.cert_number)
      ).slice(0, 6)

      const sixDigitNumbers = shuffleArray(
        allNumbers.filter(n => n.cert_number.length === 6)
          .map(n => n.cert_number)
      ).slice(0, 6)

      const eightDigitNumbers = shuffleArray(
        allNumbers.filter(n => n.cert_number.length === 8)
          .map(n => n.cert_number)
      ).slice(0, 6)

      console.log('Numbers selected:', {
        three: threeDigitNumbers.length,
        six: sixDigitNumbers.length,
        eight: eightDigitNumbers.length
      })

      return {
        threeDigit: threeDigitNumbers,
        sixDigit: sixDigitNumbers,
        eightDigit: eightDigitNumbers
      }
    }
  })

  const { data: recentNumbers } = useQuery({
    queryKey: ['recent-numbers'],
    queryFn: async () => {
      console.log('Fetching recent numbers...')
      const { data, error } = await supabase
        .from('cert_applications')
        .select('cert_number')
        .not('domain', 'eq', 'PENDING')
        .eq('status', 'approved')
        .order('created_at', { ascending: false })
        .limit(6)

      if (error) {
        console.error('Error fetching recent numbers:', error)
        throw error
      }

      return data.map(item => item.cert_number)
    }
  })

  return {
    customNumbers,
    recentNumbers,
    refetch
  }
}